import Script from 'next/script';

const DEFAULT_TARGET_ID = 'hubspot-form-container';

// Renders a HubSpot form from `hubspotFormCode`. Exported so other content
// types (e.g. Banner Layout05) can embed a form without duplicating the
// script + create-form dance.
export function HubspotFormEmbed({ hubspotFormCode, targetId = DEFAULT_TARGET_ID, className }) {
    if (!hubspotFormCode) return null;

    const { externalScript, formConfig } = extractScripts(hubspotFormCode);
    if (!externalScript) return null;

    const loadHubspotForm = () => {
        window.hbspt?.forms?.create({
            ...formConfig,
            target: `#${targetId}`
        });
    };

    return (
        <>
            <Script
                crossOrigin="anonymous"
                src={externalScript}
                onReady={loadHubspotForm}
                strategy="lazyOnload"
            />
            <div id={targetId} className={className ?? 'min-h-[400px]'} />
        </>
    );
}

export const HubspotForm = (contentlet) => (
    <HubspotFormEmbed hubspotFormCode={contentlet.hubspotFormCode} />
);

const extractScripts = (widgetCode) => {
    const externalScriptMatch = widgetCode.match(/<script[^>]*src="([^"]*)"[^>]*><\/script>/i);

    // Extract the object passed to hbspt.forms.create
    const formConfigMatch = widgetCode.match(/hbspt\.forms\.create\(([\s\S]*?)\);/);

    let formConfig = null;

    if (formConfigMatch && formConfigMatch[1]) {
        const configString = formConfigMatch[1].trim();

        try {
            formConfig = JSON.parse(configString);
        } catch (error) {
            try {
                formConfig = Function(`return ${configString}`)();
            } catch (evalError) {
                console.error('Error parsing form configuration:', evalError);
            }
        }
    }
    return {
        externalScript: externalScriptMatch ? externalScriptMatch[1] : null,
        formConfig: formConfig
    };
};
